  document.addEventListener('DOMContentLoaded', function () {
    var trigger =
      document.getElementById('cookie-preferences-button') ||
      document.getElementById('cookie-preferences-link');

    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      // Standard-Banner von Shopify erneut öffnen
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  });